<script setup lang="ts">
import unexpectedEventsAndLongTimeContinuousDrivingExtensions from "src/types/responses/unexpectedEventsAndLongTimeContinuousDrivingExtensions";
import { computed } from 'vue';

const props = defineProps<{
  item: unexpectedEventsAndLongTimeContinuousDrivingExtensions
  deleteAuthority: boolean
  openUnexpectedModal: (item: unexpectedEventsAndLongTimeContinuousDrivingExtensions) => void
  openDeleteConfirmModal: (item: unexpectedEventsAndLongTimeContinuousDrivingExtensions) => void
}>()

const displayEditIcon = computed(() => (division: string) => {
  return division == 'unexpected_events'
})

const displayDeleteIcon = computed(() => (item: unexpectedEventsAndLongTimeContinuousDrivingExtensions) => {
  return !item.ignore
})
</script>
<template>
  <div
    class="d-flex"
    :class="displayEditIcon(item.division_name) ? 'justify-space-between' : 'justify-end'"
    style="width: 75%"
  >
    <div
      class="h-100 d-flex align-center edit-or-alert-icon"
      v-if="displayEditIcon(item.division_name)"
      @click="props.openUnexpectedModal(item)"
    >
      <span
        class="material-symbols-outlined"
      >
        edit_note
      </span>
    </div>
    <div
      class="h-100 d-flex align-center edit-or-alert-icon"
      v-if="displayDeleteIcon(item) && props.deleteAuthority"
      @click="props.openDeleteConfirmModal(item)"
    >
      <span
        class="material-symbols-outlined"
        style="color: red"
      >
        delete
      </span>
    </div>
  </div>
</template>
<style scoped>
.edit-or-alert-icon:hover {
  cursor: pointer;
  opacity: 0.5;
}
</style>
